/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * BarcodeIcon
 */
export default class BarcodeIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M3 4a1 1 0 01.993.883L4 5v14a1 1 0 01-.883.993L3 20H2a1 1 0 01-.993-.883L1 19V5a1 1 0 01.883-.993L2 4h1zm3 0a1 1 0 01.993.883L7 5v14a1 1 0 01-1.993.117L5 19V5a1 1 0 011-1zm4 0a1 1 0 01.993.883L11 5v14a1 1 0 01-1.993.117L9 19V5a1 1 0 011-1zm9 0a1 1 0 01.993.883L20 5v14a1 1 0 01-1.993.117L18 19V5a1 1 0 011-1zm3 0a1 1 0 01.993.883L23 5v14a1 1 0 01-1.993.117L21 19V5a1 1 0 011-1zm-7 0a1 1 0 01.993.883L16 5v14a1 1 0 01-.883.993L15 20h-2a1 1 0 01-.993-.883L12 19V5a1 1 0 01.883-.993L13 4h2z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

